import { render, staticRenderFns } from "./EachTownStreetConstructionByLocalElderNumber.vue?vue&type=template&id=00f13a1c&scoped=true&"
import script from "./EachTownStreetConstructionByLocalElderNumber.vue?vue&type=script&lang=js&"
export * from "./EachTownStreetConstructionByLocalElderNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f13a1c",
  null
  
)

export default component.exports